import {
  ApolloCache,
  NormalizedCacheObject,
  useMutation,
} from '@apollo/client';
import { gql } from '@/__generated__';

export const FollowStream = gql(`
  mutation FollowStream($streamId: ID!) {
    followStream(streamId: $streamId)
  }
`);

export const UnfollowStream = gql(`
  mutation UnfollowStream($streamId: ID!) {
    unfollowStream(streamId: $streamId)
  }
`);

export const StreamFollowingFragment = gql(`
fragment StreamFollowingFragment on Stream {
  following
  accessAllowed
}`);

export const writeStreamFollowingFragment = (
  cache: ApolloCache<NormalizedCacheObject>,
  streamId: string,
  following: boolean,
) => {
  cache.writeFragment({
    id: cache.identify({
      __typename: 'Stream',
      id: streamId,
    }),
    fragment: StreamFollowingFragment,
    data: { __typename: 'Stream', following, accessAllowed: following },
  });
};

export const useFollowStream = (streamId: string) => {
  const [followMutation, result] = useMutation(FollowStream, {
    update(cache, { data }) {
      if (data?.followStream) {
        writeStreamFollowingFragment(cache, streamId, data.followStream);
      }
    },
  });

  const followStream = () => {
    return followMutation({
      variables: {
        streamId,
      },
      // we can't start fetching stream posts until stream is followed on backend
      // TODO: pass mutation's loading state to stream posts feed so we can skip query while it's loading
    });
  };

  return [followStream, result] as const;
};

export const useUnfollowStream = (streamId: string) => {
  const [unfollowMutation, result] = useMutation(UnfollowStream, {
    update(cache, { data }) {
      if (data?.unfollowStream) {
        writeStreamFollowingFragment(cache, streamId, !data.unfollowStream);
      }
    },
  });

  const unfollowStream = () => {
    return unfollowMutation({
      variables: {
        streamId,
      },
      optimisticResponse: {
        unfollowStream: true,
      },
    });
  };

  return [unfollowStream, result] as const;
};
